import { useEffect, useState } from "react";

export default function FirstVisitModal() {
  const [showModal, setShowModal] = useState(false);
  const [showVideo, setShowVideo] = useState(false);

  // Show modal after 1.2 seconds
  useEffect(() => {
    const hasSeenModal = sessionStorage.getItem("hasSeenWelcomeModal");

    if (hasSeenModal) return;

    const modalTimer = setTimeout(() => {
      setShowModal(true);
    }, 1200);

    return () => clearTimeout(modalTimer);
  }, []);

  // Show image for 5 seconds, then switch to video
  useEffect(() => {
    if (!showModal) return;

    setShowVideo(false);

    const videoTimer = setTimeout(() => {
      setShowVideo(true);
    }, 5000);

    return () => clearTimeout(videoTimer);
  }, [showModal]);

  const closeModal = () => {
    setShowModal(false);
    sessionStorage.setItem("hasSeenWelcomeModal", "true");
  };

  if (!showModal) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80 p-3 sm:p-4">
      {!showVideo ? (
        /* ================= IMAGE ================= */
        <div className="relative flex items-center justify-center">
          <img
            src="/banner5.jpeg"
            alt="LifeOnPlus"
            className="
              block
              h-auto
              w-auto
              max-w-[95vw]
              max-h-[95vh]
              object-contain
            "
          />
        </div>
      ) : (
        /* ================= VIDEO ================= */
        <div className="relative w-full max-w-4xl overflow-hidden rounded-2xl bg-white shadow-2xl">
          {/* Video Header */}
          <div className="flex items-center justify-between border-b border-gray-200 bg-white px-4 py-3 sm:px-5 md:px-6">
            <h2 className="text-lg font-bold text-green-700 sm:text-xl md:text-2xl">
              Welcome to LifeOnPlus
            </h2>

            <button
              type="button"
              onClick={closeModal}
              aria-label="Close welcome video"
              className="
                flex h-9 w-9 items-center justify-center
                rounded-full
                text-2xl
                leading-none
                text-gray-400
                transition-colors
                hover:bg-gray-100
                hover:text-gray-700
              "
            >
              &times;
            </button>
          </div>

          {/* Video */}
          <div className="relative aspect-video w-full bg-black">
            <iframe
              className="absolute inset-0 h-full w-full"
              src="https://www.youtube.com/embed/WwSbh4Ft1Fs?autoplay=1&rel=0&modestbranding=1"
              title="Welcome to LifeOnPlus"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
        </div>
      )}
    </div>
  );
}
